import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from './cn.js';
import { useOverlayContainer } from './overlay-container.js';
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverClose = PopoverPrimitive.Close;
/**
 * Small content anchored to a trigger: the health-dot service list, "More
 * filters", a column picker. `popover` surface, `shadow-2`, 12 px padding,
 * zooms from 96 %; closes on outside click and Escape and returns focus to
 * the trigger. A form with a submit inside is a sheet or a dialog, not this.
 */
const PopoverContent = React.forwardRef(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (_jsx(PopoverPrimitive.Portal, { container: useOverlayContainer(), children: _jsx(PopoverPrimitive.Content, { ref: ref, align: align, sideOffset: sideOffset, "data-slot": "popover-content", className: cn('z-50 w-72 rounded-md border bg-popover p-3 text-ui text-popover-foreground shadow-md outline-none', 'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', className), ...props }) })));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverClose };
//# sourceMappingURL=popover.js.map